import axios from 'axios';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


function PostCollege() {
         const [startDate, setStartDate] = useState(new Date());
         const { register, handleSubmit,reset } = useForm();
         const onSubmit = data => {
                     console.log(data);
                     axios.post('https://education-info-server-production.up.railway.app/addCollege', data)
                     .then(res=>{
                              console.log(res);
                              if(res.data.insertedId){
                                alert('Added in Post College Info!');
                                reset();
                              }
                     })
};

  return (
    <>
   <div className='add-service'>
    <Helmet>
        <title>College information</title>
        <meta 
           name='description'
           content='women empowerment blog post'
         />
      </Helmet>
      <h1 className='titleStyle'><span className='title'>College information</span></h1>
      <h1 className='bottomText mb-6'><span className='title'>Hey, Admin!<br/>Post College Info!</span></h1>
         {/**React-hook-form */}
         <form onSubmit={handleSubmit(onSubmit)}>
      <input {...register("Date", { required: true, maxLength: 20 })} className="text-xs" placeholder='Date *' />
      <input {...register("Title", { required: true, maxLength: 100 })} className="text-xs" placeholder='School Topics Name* '/>
      <input {...register("Location", { required: true, maxLength: 100 })} className="text-xs" placeholder='Location for this Post*'/>
      
      <input {...register("Link", { required: true, maxLength: 3000 })} className="text-xs" placeholder='Related links *'/>
      <input {...register("Details", { maxLength: 1500 })} className="text-xs" placeholder='Detail related with this exam '/>
      
      <input {...register("Image", {  maxLength: 1000 })} className="text-xs" placeholder="Image URL"/>
      <input style={{backgroundColor:'salmon', color:'#fff',fontWeight:'bold',width:'30%', marginTop:'40px'}} type="submit" />
    </form>
    </div>
    </>

  )
}

export default PostCollege;